import { render, staticRenderFns } from "./EndCeremony.vue?vue&type=template&id=060790c2&scoped=true"
import script from "./EndCeremony.vue?vue&type=script&lang=js"
export * from "./EndCeremony.vue?vue&type=script&lang=js"
import style0 from "./EndCeremony.vue?vue&type=style&index=0&id=060790c2&prod&scoped=true&lang=scss"
import style1 from "./EndCeremony.vue?vue&type=style&index=1&id=060790c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060790c2",
  null
  
)

export default component.exports